import React from 'react'
import { TouchableOpacity, View } from 'react-native'
import { startCase } from 'lodash'
import { useNavigation } from '@react-navigation/native'
import { StackNavigationProp } from '@react-navigation/stack'
import { StyleService, useStyleSheet } from '@style/service.ts'
import { HealthDataReport } from '@src/types.ts'
import { Icon, Text } from '@src/components/base'
import { AppStackParamList } from '@src/navigation/types'
import { formatReportDateRange, isReportUnread } from '../utils'

interface ReportCardProps {
  report: HealthDataReport
}

export const ReportCard = ({ report }: ReportCardProps) => {
  const styles = useStyleSheet(themedStyle)
  const navigation = useNavigation<StackNavigationProp<AppStackParamList>>()
  const unread = isReportUnread(report)

  const openReport = (report: HealthDataReport) => {
    navigation.navigate('NoraReportScreen', { report })
  }

  return (
    <TouchableOpacity
      style={[styles.reportCard, unread && styles.unreadReportCard]}
      accessibilityLabel={startCase(report.kind)}
      onPress={() => openReport(report)}
    >
      <View style={styles.reportInfo}>
        <Text type="regular" bold={unread}>
          {startCase(report.kind)}
        </Text>
        <Text type="small" style={styles.dateText}>
          {formatReportDateRange(report)}
        </Text>
      </View>
      <Icon name="caret-right" size="20" />
    </TouchableOpacity>
  )
}

const themedStyle = StyleService.create({
  reportCard: {
    paddingHorizontal: 16,
    paddingVertical: 8,
    borderRadius: 8,
    borderColor: 'theme.surface.base1',
    borderWidth: 1,
    flexDirection: 'row',
    gap: 8,
    alignItems: 'center',
    justifyContent: 'space-between',
    marginBottom: 8,
  },
  unreadReportCard: {
    backgroundColor: 'theme.surface.base3',
  },
  reportInfo: {
    flex: 1,
    gap: 4,
  },
  dateText: {
    color: 'theme.text.secondary',
  },
})
